import { compact, isEmpty } from "lodash/fp";

import { EnterpriseUserBody } from "@app/common/account/api";
import { get, post } from "@app/common/api";
import {
  EnterpriseTeam,
  EnterpriseWorkspaceUser,
} from "@app/common/workspaces/types";
import { isPromiseFulfilled } from "@app/utils/utils";

export const getTeam = async (
  workspaceId: string,
  teamId: string
): Promise<EnterpriseTeam> => {
  const team: EnterpriseTeam = await get(
    `/enterprise/workspaces/${workspaceId}/teams/${teamId}`,
    { withCreds: true }
  );
  // The API can return null settings. Protect against
  // that, so we don't need null checks
  team.settings = team.settings ?? {};
  return team;
};

const createTeamUser = async (
  workspaceId: string,
  teamId: string,
  user: EnterpriseUserBody
) => {
  return post(
    `/enterprise/workspaces/${workspaceId}/teams/${teamId}/users`,
    user,
    { withCreds: true }
  );
};

export const addUsersToTeam = async ({
  workspaceId,
  teamId,
  users,
}: {
  workspaceId: string;
  teamId: string;
  users: EnterpriseWorkspaceUser[];
}): Promise<EnterpriseWorkspaceUser[]> => {
  if (isEmpty(users)) return [];

  const results = await Promise.allSettled(
    users.map((u) =>
      createTeamUser(workspaceId, teamId, {
        userId: u.userId,
        role: "member",
      })
    )
  );

  const failedUsers = results.map((result, i) =>
    isPromiseFulfilled(result) ? null : users[i]
  );

  return compact(failedUsers);
};
